
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.955 40H3.516A3.52 3.52 0 010 36.484V3.515A3.52 3.52 0 013.516 0H23.64a3.492 3.492 0 012.486 1.03l3.315 3.315a3.493 3.493 0 011.03 2.485v9.287l1.768-1.77L34 12.588a3.516 3.516 0 114.972 4.972l-8.5 8.5v10.424A3.52 3.52 0 0126.955 40zM3.516 2.344a1.174 1.174 0 00-1.172 1.171v32.969a1.174 1.174 0 001.173 1.172h23.438a1.173 1.173 0 001.172-1.172v-8.075l-.142.142a1.178 1.178 0 01-.458.284l-4.972 1.657a1.173 1.173 0 01-1.483-1.482l1.658-4.972a1.178 1.178 0 01.284-.458l1.656-1.657 3.458-3.461V9.375h-5.86A1.173 1.173 0 0121.1 8.2V2.344zM25.5 24.408l-.634.634-.828 2.486 2.486-.829.633-.633-1.657-1.658zm7.291-7.3l-2.734 2.736-.2.2-2.7 2.7 1.658 1.657 5.633-5.638-1.658-1.65zm3.694-3.21a1.164 1.164 0 00-.829.343l-1.209 1.21 1.653 1.661 1.211-1.212a1.171 1.171 0 00-.828-2zM23.565 2.343h-.125v4.688h4.687V6.98a1.237 1.237 0 00-.343-.98l-3.315-3.313a1.194 1.194 0 00-.904-.344z","fill":"#56bdd2"}})])
          )
        }
      }
    